export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'User', url: '/user', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
